const React = require('react')
const { useState } = require('react')
const { useHistory } = require('react-router-dom')
const { Card, CardHeader, CardBody, Collapse, Button } = require('reactstrap')
const { useNetworkConfig } = require('@contexts')

require('@styles/pages/verifyContract/index.css')

const Fail = props => {
    const { data } = props
    const history = useHistory()
    const { network } = useNetworkConfig()

    const [isFailOpen, setIsFailOpen] = useState(true)
    const [isCompilerWarningOpen, setIsCompilerWarningOpen] = useState(true)
    const [isCompilerDebugLogOpen, setIsCompilerDebugLogOpen] = useState(true)

    return (
        <>
            <Card className='box table-section' style={{ padding: '0px', border: 'none' }}>
                <CardHeader
                    className='verify-card-header cursor-pointer'
                    onClick={() => setIsFailOpen(!isFailOpen)}
                    style={{
                        border: !isFailOpen && 'none',
                        borderColor: isFailOpen && 'var(--dropdown-background)'
                    }}
                >
                    <div>
                        <div style={{ fontWeight: 'bold' }}>
                            <span>Compiler Output</span>
                        </div>
                    </div>
                    <i className={`fas fa-angle-${isFailOpen ? 'up' : 'down'}`} />
                </CardHeader>
                <Collapse isOpen={isFailOpen}>
                    <CardBody>
                        {data?.warnings && (
                            <Card
                                className='box table-section'
                                style={{ padding: '0px', border: '1px solid var(--dropdown-background)' }}
                            >
                                <CardHeader
                                    className='verify-card-header cursor-pointer'
                                    onClick={() => setIsCompilerWarningOpen(!isCompilerWarningOpen)}
                                    style={{
                                        border: !isCompilerWarningOpen && 'none',
                                        borderColor: isCompilerWarningOpen && 'var(--dropdown-background)'
                                    }}
                                >
                                    <div>
                                        <div style={{ fontWeight: 'bold' }}>
                                            <span>Compiler Warning(s)</span>
                                        </div>
                                    </div>
                                    <i className={`fas fa-angle-${isCompilerWarningOpen ? 'up' : 'down'}`} />
                                </CardHeader>
                                <Collapse isOpen={isCompilerWarningOpen}>
                                    <CardBody>
                                        {data?.warnings.map(warning => (
                                            <div style={{ fontFamily: 'monospace' }}>{warning}</div>
                                        ))}
                                    </CardBody>
                                </Collapse>
                            </Card>
                        )}

                        <Card
                            className='box table-section'
                            style={{ padding: '0px', border: '1px solid var(--dropdown-background)' }}
                        >
                            <CardHeader
                                className='verify-card-header cursor-pointer'
                                onClick={() => setIsCompilerDebugLogOpen(!isCompilerDebugLogOpen)}
                                style={{
                                    border: !isCompilerDebugLogOpen && 'none',
                                    borderColor: isCompilerDebugLogOpen && 'var(--dropdown-background)'
                                }}
                            >
                                <div>
                                    <div style={{ fontWeight: 'bold' }}>
                                        <span>Compiler Debug Log</span>
                                    </div>
                                </div>
                                <i className={`fas fa-angle-${isCompilerDebugLogOpen ? 'up' : 'down'}`} />
                            </CardHeader>
                            <Collapse isOpen={isCompilerDebugLogOpen}>
                                <CardBody>
                                    <li>
                                        For troubleshooting, you can try compiling your source code with the&nbsp;
                                        <span
                                            className={`${network.name}-text-color cursor-pointer`}
                                            onClick={() => window.open('https://remix.ethereum.org/', '_blank')}
                                        >
                                            Remix - Solidity IDE
                                        </span>
                                        &nbsp;and check for exceptions
                                    </li>
                                </CardBody>
                            </Collapse>
                        </Card>
                        <div
                            style={{
                                backgroundColor: 'var(--dropdown-background)',
                                borderRadius: '8px',
                                padding: '16px',
                                margin: '16px 0'
                            }}
                        >
                            <div style={{ marginBottom: '8px' }}>
                                <span style={{ fontWeight: 'bold' }}>Compiler Version:</span>
                                &nbsp;{data?.compilerVersion}
                            </div>
                            <div style={{ marginBottom: '8px' }}>
                                <span style={{ fontWeight: 'bold' }}>Optimization Enabled:</span>
                                &nbsp;{data?.optimizationUsed ? 'Yes' : 'No'}
                            </div>
                            <div style={{ marginBottom: '8px' }}>
                                <span style={{ fontWeight: 'bold' }}>Runs:</span>
                                &nbsp;
                                {data?.optimizationUsed ? data?.runs : 0}
                            </div>
                        </div>

                        <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                            Bytecode (what we are looking for)
                        </div>
                        <div
                            style={{
                                backgroundColor: 'var(--dropdown-background)',
                                borderRadius: '8px',
                                padding: '16px',
                                margin: '16px 0',
                                maxHeight: '200px',
                                overflowY: 'auto',
                                fontFamily: 'monospace'
                            }}
                        >
                            {data?.bytecode}
                        </div>
                        {data?.bytecodes.length && (
                            <>
                                <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>- vs what we got -</div>
                                <div
                                    style={{
                                        backgroundColor: 'var(--dropdown-background)',
                                        borderRadius: '8px',
                                        padding: '16px',
                                        margin: '16px 0',
                                        maxHeight: '200px',
                                        overflowY: 'auto',
                                        overflowX: 'auto',
                                        whiteSpace: 'pre'
                                    }}
                                >
                                    We tried looking for a match from the list of compiled contract bytecode outputs (as
                                    listed below), but was unable to find an exact match.
                                    {data?.bytecodes
                                        .filter(contract => contract.bytecode)
                                        .map((contract, index) => (
                                            <div>
                                                <br />
                                                <div>
                                                    {index + 1}/&nbsp;
                                                    <span style={{ fontWeight: 'bold' }}>{contract.name}</span>
                                                </div>
                                                <div style={{ fontFamily: 'monospace' }}>{contract.bytecode}</div>
                                            </div>
                                        ))}
                                </div>
                            </>
                        )}
                    </CardBody>
                </Collapse>
            </Card>
            <div className='d-flex justify-content-center' style={{ margin: '24px 0' }}>
                <Button
                    onClick={() => {
                        window.location.reload()
                    }}
                    style={{
                        background: 'transparent',
                        border: 'none',
                        minWidth: '120px',
                        color: 'var(--grey-color)',
                        cursor: 'pointer'
                    }}
                >
                    <i className='fas fa-arrow-left' /> &nbsp;Start Over
                </Button>
            </div>
        </>
    )
}

module.exports = { Fail }
